<label class="input-row" [class.mod-grow]="grow">
  <span *ngIf="label" class="label">{{label | translate}}</span>
  <div class="validated-input" [ngClass]="inputClass">
    <input
      class="input outline"
      [ngClass]="mergedInputClass"
      [type]="type"
      [id]="inputId"
      [name]="inputId"
      [formControl]="cpFormControl"
      [(ngModel)]="cpModel"
      [class.mod-large]="large"
      [attr.placeholder]="placeholder | translate" />
    <cp-validation-error *ngIf="showErrors" [class]="errorClass" [errors]="explicitError || cpFormControl.errors" [validate]="validate">
    </cp-validation-error>
  </div>
</label>
